import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";
import { parseParams } from "../../../helpers/clean-object";
import {
  CreateProductMutation,
  CreateProductMutationVariables,
} from "../../../__generated__/CreateProductMutation";
import { CreateProductInput } from "../../../__generated__/globalTypes";
import { CREATE_PRODUCT } from "../products.queries";

interface IProps {
  defaultValues: DeepPartial<CreateProductInput>;
  onCompleted: (id: number) => any;
  onError: (msg: string) => any;
}

export const useCreateProduct = ({
  defaultValues,
  onCompleted,
  onError,
}: IProps) => {
  const form = useForm<CreateProductInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateProductMutation,
    CreateProductMutationVariables
  >(CREATE_PRODUCT);

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createProduct?.ok && data?.createProduct?.id) {
        onCompleted(data?.createProduct?.id);
      } else {
        throw Error(data?.createProduct?.error ?? "Error");
      }
    } catch ({ message = "" }) {
      onError(message);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
